import consumer from "./consumer"

const displaySuccessMessage = (data) => {
  document.dispatchEvent(
    new CustomEvent('promote:display-success-message', { detail: data })
  )
}

const displayErrorMessage = (data) => {
  document.dispatchEvent(
    new CustomEvent('promote:display-error-message', {detail: data})
  )
}

const displayMessage = (data) => {
  if (data.error) {
    displayErrorMessage(data);
  } else {
    displaySuccessMessage(data);
  }
}

window.subscribeToNotificationsChannel = (userId) => {
  return consumer.subscriptions.create(
    {
      channel: "NotificationsChannel",
      user_id: userId
    },
    {
      connected() {
      },

      disconnected() {
      },

      received(data) {
        if (data.type === "program_copy") {
          displaySuccessMessage(data);
        } else if (data.type === "program_translation") {
          displaySuccessMessage(data);
          document.dispatchEvent(
            new CustomEvent('promote:program-translation-status-changed')
          );
        } else if (data.type === "scorm_upload_response") {
          displayMessage(data);
        } else if (data.type === "bulk_user_deletion") {
          displayMessage(data);
        }
      }
    }
  )
}
